export const ID_INVOICE_FULL_PERIOD ='INVOICE_FULL_PERIOD';
export const ID_CHANGE_CHECKIN_DATE = 'CHANGE_CHECKIN_DATE';
export const ID_ADD_DAYS_NUMBER = 'ADD_DAYS_NUMBER';